/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>device-property-type.model.ts</name>
///
/// <description>
/// A class for device data
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>16 Sep 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 16Sep16 YH  1.0.0000         First cut
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
///

export enum DevicePropertyType {
    GetValue, 
    Selectable,
    Conflicted,
    Inherited,
    Apply,
    Pending,
    Unsupported
}


// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/models/device-data-models/device-property-type.model.ts